const PAGE_TITLE = 'Style & layout';

const STYLE_LAYOUT_PAGE_CONSTANTS = Object.freeze({
  pageTitle: PAGE_TITLE,
});

export { STYLE_LAYOUT_PAGE_CONSTANTS };
